<!--SKU编辑  -->
<template>
	<el-dialog
		title="价格体系信息"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		width="600px">
		<div class="form-box">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="80px">

				<el-form-item label="体系名称" prop="priceName">
					<el-input v-model.trim="dataForm.priceName" maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model.trim="dataForm.remark" type="textarea" :rows="2" maxlength="50"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button  size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button  size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				dataForm: {
					priceName: '',
					startDate: "",
					endDate: "",
					priorityLevel: "",
					remark: ""
				},
				rules: {
					priceName: [
						{
							required: true,
							message: '请输入体系名称',
							trigger: 'blur'
						}
					],
					startDate: [
						{
							required: true,
							message: '请选择生效日期',
							trigger: 'blur'
						}
					],
					endDate: [
						{
							required: true,
							message: '请选择终止日期',
							trigger: 'blur'
						}
					],
					priorityLevel: [
						{
							required: true,
							message: '请输入优先级',
							trigger: 'blur'
						},
						{pattern: /^[0-9]\d*$/, message: '请输入数字'}
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(isEdit,dt) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					delete this.dataForm.priceId;
					this.dataForm.priorityLevel=""
					this.dataForm.priorityLevel = dt?dt+1:""
					if(isEdit==2&&dt) {
						this.dataForm.priceId = dt.priceId;
						this.dataForm.priceName = dt.priceName;
						this.dataForm.startDate = dt.startDate;
						this.dataForm.endDate = dt.endDate;
						this.dataForm.priorityLevel = dt.priorityLevel;
						this.dataForm.remark = dt.remark;
					}
				})
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				if(this.dataForm.startDate > this.dataForm.endDate) {
					this.$message.error('生效日期不能大于终止日期');
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							this.dataForm.priceType = 1;
							let that = this;
							that.$request.post(
								that.dataForm.priceId ? 'updatePriceMain' : 'addPriceMain',
								true, that.dataForm
							)
							.then((res) => {
								if (res) {
									that.dialogVisible = false;
									that.$emit('getPriceList');
									that.$message.success('保存成功');
								}
							})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}
	.red-tip{
		color: red;
		// color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
	}
</style>
